import PropTypes from 'prop-types';
import AidRectCheckbox from '../AidRectCheckbox';
import { RectCheckboxGroupContextProvider } from '../../utils/rectCheckboxContext';
import rectCheckbox from './groupRectCheckbox.module.scss';

function GroupRectCheckbox(props) {
  const {
    options, defaultValue, style, onChange, unit, isTop,
  } = props;

  const onRectCheckboxChange = (e) => {
    onChange(e);
  };

  const renderRectCheckbox = () => options.map((item, index) => (
    <AidRectCheckbox
      key={item.key}
      index={item.key}
      text={item.name}
      checked={defaultValue === item.key}
      style={{ ...style, marginTop: index > 1 ? style.marginRight : 0 }}
      icon={item.icon}
      unit={unit}
      isTop={isTop}
    />
  ));

  return (
    <RectCheckboxGroupContextProvider value={{ onChange: onRectCheckboxChange }}>
      <div className={rectCheckbox['rect-checkbox']}>
        {
          renderRectCheckbox()
        }
      </div>
    </RectCheckboxGroupContextProvider>
  );
}

GroupRectCheckbox.propTypes = {
  options: PropTypes.oneOfType([PropTypes.array]),
  defaultValue: PropTypes.string,
  unit: PropTypes.string,
  onChange: PropTypes.func,
  isTop: PropTypes.bool,
  style: PropTypes.oneOfType([PropTypes.object]),
};
GroupRectCheckbox.defaultProps = {
  options: [],
  defaultValue: '',
  style: {},
  unit: 'rem',
  isTop: false,
  onChange: () => {},
};

export default GroupRectCheckbox;
